import LeadListCardView from './LeadListCardView';

export default LeadListCardView;
